// <s-wishlist-toggle> saves or removes one product handle in this browser's wishlist (localStorage) and keeps its heart button's pressed state in sync.
const STORAGE_KEY = 'muc-wishlist';
const CHANGE_EVENT = 'muc:wishlist-change';

const readList = () => {
  try {
    const value = JSON.parse(localStorage.getItem(STORAGE_KEY) ?? '[]');
    return Array.isArray(value) ? value : [];
  } catch {
    return [];
  }
};

class SWishlistToggle extends HTMLElement {
  #button;

  connectedCallback() {
    this.#button = this.querySelector('button');
    if (!this.#button || !this.dataset.handle) return;
    this.#button.addEventListener('click', this.#toggle);
    window.addEventListener(CHANGE_EVENT, this.#sync);
    window.addEventListener('storage', this.#sync);
    this.#sync();
  }

  disconnectedCallback() {
    window.removeEventListener(CHANGE_EVENT, this.#sync);
    window.removeEventListener('storage', this.#sync);
  }

  #toggle = () => {
    const handle = this.dataset.handle;
    const list = readList();
    const next = list.includes(handle) ? list.filter((item) => item !== handle) : [handle, ...list];
    try {
      localStorage.setItem(STORAGE_KEY, JSON.stringify(next));
    } catch {
      return;
    }
    window.dispatchEvent(new CustomEvent(CHANGE_EVENT));
  };

  #sync = () => {
    this.#button.setAttribute('aria-pressed', String(readList().includes(this.dataset.handle)));
  };
}

if (!customElements.get('s-wishlist-toggle')) customElements.define('s-wishlist-toggle', SWishlistToggle);
